import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './api/auth.service';
import { MyEventService } from './core/event.service';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    public updates: SwUpdate,
    private alertCtrl: AlertController,
    private myEventService: MyEventService,
    private translateService: TranslateService,
    private authService: AuthService,
    private changeRef: ChangeDetectorRef,
    private router: Router,
  ) {
    updates.versionUpdates.subscribe((e) => {
      updates.versionUpdates.
        pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'), map(evt => ({ type: 'UPDATE_AVAILABLE', current: evt.currentVersion, available: evt.latestVersion, }))).subscribe(evt => {
          console.log(evt);
          if (evt.current !== evt.available) {
            this.alertCtrl.create({
              header: 'Update Available',
              message: 'This version will now be installed',
              buttons: ['OK']
            }).then((alert) => {
              alert.present();
              alert.onDidDismiss().then(() => {
                this.router.navigate(['/login']).then(() => {
                  setTimeout(() => {
                    document.location.reload();
                  }, 500)
                });
              });
            });
          }
        });
    });

    if ((window as any).cordova) {
      CapacitorUpdater.addListener('updateAvailable', async (res) => {
        const alert = await this.alertCtrl.create({
          header: 'Update Available',
          message: `Version ${res.bundle.version} is available. The app will update now`,
          buttons: ['OK']
        });
        await alert.present();
        await alert.onDidDismiss()
        CapacitorUpdater.set(res.bundle);
      });
    }

    this.myEventService.subscribe('auth.revoked', () => {
      localStorage.clear();
      this.translateService.use(this.authService.getLanguage())
      this.changeRef.detectChanges();
    });

    this.myEventService.subscribe('auth.created', () => {
      if (!localStorage.getItem('prefLanguage')) {
        localStorage.setItem('prefLanguage', this.authService.getLanguage());
        this.translateService.use(this.authService.getLanguage())
        this.changeRef.detectChanges();
      } else {
        this.translateService.use(localStorage.getItem('prefLanguage'));
      }
    });

  }
}